const config = {
    token: "413ad652513c2b0172e59ef9b2efb4b0f254cafe64e37480e764257345ff8d6c",
    adminToken:
        "1db47f68a6a1e3e5052c5fa0e603d871eb1f0d54125a0cff3a6dc2c17fd339cb",
    BASE_URL: "https://pencilapi.serendipitymedia.tech",
    primary_color: "#fcb763",
};

export default config;
